/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CircleButton, Icon } from '@fnacdarty/back-office-ui';
import { useTheme } from 'styled-components';
import {
	DropDownContainer,
	DropDownListContainer,
	DropDownList,
	ListItem,
	StyledButton,
	StyledIcon,
	DropdownHeaderIcon,
} from './index.styled';

const ActionMenu = ({ label, actions, setAction, showIcon }) => {
	const theme = useTheme();
	const [isOpen, setIsOpen] = useState(false);
	const toggleMenu = () => setIsOpen(!isOpen);
	const selectAction = (value) => () => {
		setAction(value);
		setIsOpen(false);
	};

	return (
		<>
			<div className="Dropdown_menu">
				<DropDownContainer>
					{showIcon && (
						<DropdownHeaderIcon onClick={toggleMenu}>
							<CircleButton
								size={50}
								color={theme.colors.primaryLight}
								className={'CircleButtonClass'}
							>
								<Icon name="plus" width={30} color="white" />
							</CircleButton>
						</DropdownHeaderIcon>
					)}
					{!showIcon && (
						<StyledButton
							onClick={toggleMenu}
							ariaLabel="Primary"
							variant="primary"
						>
							<span>{label}</span>
							<StyledIcon
								width="20px"
								color="white"
								name={isOpen ? 'chevron-down' : 'chevron-right'}
							/>
						</StyledButton>
					)}
					{isOpen && (
						<DropDownListContainer showicon={showIcon}>
							<DropDownList>
								{actions.map((action) => (
									<ListItem
										onClick={selectAction(action.value)}
										key={Math.random()}
									>
										{action.label}
									</ListItem>
								))}
							</DropDownList>
						</DropDownListContainer>
					)}
				</DropDownContainer>
			</div>
		</>
	);
};

ActionMenu.propTypes = {
	label: PropTypes.string,
	actions: PropTypes.array,
	setAction: PropTypes.func,
	showIcon: PropTypes.bool,
};

export default ActionMenu;
